<template>
  <section class="order-confirmation pt-6 mx-auto w-10/12">
    <div class="flex flex-col text-primary-default">
      <div class="flex font-bold text-xl mx-4 my-2 justify-start">Order is met succes verzonden!</div>
      <div class="flex text-base mx-4 my-2 justify-start">
        Hartelijk dank voor uw bestelling. We gaan direct voor u aan de slag.
      </div>
      <div class="flex text-xl mx-4 my-2 justify-start">Overzicht van uw bestelling</div>
      <div class="flex flex-col text-base mx-4 my-2 justify-start">
        <div class="rounded-lg flex flex-row w-full">
          <div
            class="bg-sky-50 hidden md:block"
            :class="[headerIndex === 0 ? 'w-1/12' : headerIndex === 1 ? 'w-5/12' : 'w-3/12']"
            v-for="(header, headerIndex) in headers"
            :key="headerIndex"
          >
            <div class="">
              <div class="flex relative">
                <div class="p-2 md:p-4 text-base text-pdsPrimaryColor font-bold">
                  {{ header }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rounded-lg">
          <div class="flex flex-row border-b border-sky-200" v-for="(product, index) in productDetails" :key="index">
            <div class="w-full">
              <div class="flex flex-col md:flex-row relative">
                <div class="p-2 md:p-4 text-base text-tdefault-color w-full md:w-1/12 font-bold">
                  <span class="inline md:hidden">Aantal: </span>
                  {{ product.quantity }}
                </div>
                <div class="p-2 md:p-4 text-base text-tdefault-color w-full md:w-5/12 font-bold">
                  <span class="inline md:hidden">Omschrijving: </span>
                  {{ $toTitleCase(product.name) }}
                </div>
                <div class="p-2 md:p-4 text-base text-tdefault-color w-full md:w-3/12 font-bold">
                  <span class="inline md:hidden">Artikelcode: </span>
                  {{ product.productCode }}
                </div>
                <div class="p-2 md:p-4 text-base text-tdefault-color w-full md:w-3/12 font-bold">
                  <span class="inline md:hidden">Verwachte bezorgdatum: </span>
                  {{ $formatDate(product.deliveryDate) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex text-base mx-4 my-2 justify-start">
        Op het patiëntendashboard kunt u alle bestellingen van uw patiënt bekijken.
      </div>
      <div class="gap-6 grid md:flex grid-cols-2 md:flex-row justify-start mx-4 my-2">
        <button
          @click.prevent="$router.push('/')"
          class="flex justify-center py-2 px-2 md:px-4 text-xs md:text-base font-medium text-pdsPrimaryColor border border-primary-default items-center bg-white rounded-full"
        >
          <span class=""> Naar mijn Dashboard</span>
        </button>
        <button
          v-if="currentRoute !== 'aanvullenmagazijnCheckout'"
          @click.prevent="$router.push('/patientdashboard')"
          class="flex justify-center py-2 px-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default rounded-full"
        >
          <span class="">Naar patiëntendashboard</span>
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, onMounted } from 'vue';
import router from '@/router';
import { fetchQuery } from '@/services/messaging/fetchQuery';
import { shoppingCart$, clearShoppingCart } from '@/services';

export default {
  name: 'VOrderconfirmation',
  setup() {
    const headers = ['Aantal', 'Omschrijving', 'Artikelcode', 'Verwachte bezorgdatum'];
    const currentRoute = ref('');
    const shoppingCart = ref();
    shoppingCart.value = shoppingCart$;
    const customerName = ref('');
    const deliveryAddress = ref('');
    const productDetails = ref([]);
    const departmentName = ref('');

    const getEcommerceData = (orders) => {
      const ecommerceData = [];
      orders.forEach((order) => {
        let orderItems = [];
        let ecommerceItem = {};
        ecommerceItem = {
          transaction_id: order.orderId,
          value: 0,
          currency: 'EUR',
          items: []
        };

        order.orderLineDetails.forEach((detail) => {
          orderItems.push({
            item_id: detail.productId,
            item_name: detail.name,
            item_brand: detail.brandOwner,
            price: 0,
            quantity: detail.quantity
          });
        });
        ecommerceItem.items = orderItems;
        (ecommerceItem.item_list_name = router.currentRoute.value.path), ecommerceData.push(ecommerceItem);
      });
      return Object.values(ecommerceData);
    };

    onMounted(() => {
      clearShoppingCart(shoppingCart.value);
      currentRoute.value = router.currentRoute.value.name;
      let orderIds = router.currentRoute.value.query.orderId;

      fetchQuery('GetOrders', { orderIds: orderIds }).then((response) => {
        customerName.value = response[0].customerName;
        deliveryAddress.value = response[0].deliveryAddress;
        departmentName.value = response[0].departmentName;
        response.forEach((data) => {
          data.orderLineDetails.forEach((orderLine) => {
            productDetails.value.push(orderLine);
          });
        });
        const ecommerceData = getEcommerceData(response);

        window.dataLayer.push({
          event: 'purchase',
          ecommerce: ecommerceData
        });
      });
    });

    return {
      headers,
      currentRoute,
      shoppingCart,
      customerName,
      deliveryAddress,
      productDetails,
      departmentName,
      getEcommerceData
    };
  }
};
</script>
